define('FilterCommerceCategories.EntryPoint',
  [
    'FilterCommerceCategories.Model',
    'Header.Menu.View',
    'jQuery',
    'underscore'
  ],
  function (
    FilterCommerceCategoriesModel,
    HeaderMenuView,
    jQuery,
    _
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp() {
        _.extend(HeaderMenuView.prototype, {
          initialize: _.wrap(HeaderMenuView.prototype.initialize, function (fn) {
            
            fn.apply(this, _.toArray(arguments).slice(1));

            var self = this;
            var host = SC.ENVIRONMENT.currentHostString;
            var currentSite = '';

            if (host.indexOf('activebowls') !== -1) {
              currentSite = '2';
            } else if (host.indexOf('henselite') !== -1) {
              currentSite = '1';
            }

            this.filteredCategories = null;
            this.loadingCategories = true;

            var model = new FilterCommerceCategoriesModel();
            model.fetch({
              data: { site: currentSite }
            }).done(function (response) {
              if (response && response.value) {
                self.filteredCategories = response.value;
              }
              self.loadingCategories = false;
              self.render();
            });
          }),

          getContext: _.wrap(HeaderMenuView.prototype.getContext, function (fn) {
            if (this.loadingCategories) {
              return { categories: [] };
            }

            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var self = this;

            function filterCategory(category) {
              if (Array.isArray(category.categories) && category.categories.length) {
                category.categories = _.filter(category.categories, function (subcat) {
                  return filterCategory(subcat);
                });
              }

              return category['data-type'] !== 'commercecategory' ||
              _.some(self.filteredCategories, function (filteredCategory) {
                return filteredCategory.urlfragment === category.href.split('/').pop();
              }) || Array.isArray(category.categories) && category.categories.length > 0;
            }

            if (self.filteredCategories) {
              context.categories = _.filter(context.categories, function (category) {
                return filterCategory(category);
              });
            }

            return context;
          })

        });
      }
    };
  });
